export default "__VITE_ASSET__Dbh32cku__"